import { z, ZodDiscriminatedUnion, ZodDiscriminatedUnionOption } from 'zod';

export const useDiscriminatedUnion = <
  Discriminator extends string,
  Options extends ZodDiscriminatedUnionOption<Discriminator>[],
>(
  union: ZodDiscriminatedUnion<Discriminator, Options>,
  watch: (key: string) => string,
  fallback: any,
) => {
  const discriminator = watch(union.discriminator) ?? fallback;
  const schema = union.optionsMap.get(discriminator) as (typeof union._def.options)[0];

  return z.object({
    [union.discriminator]: z.nativeEnum(
      Array.from(union._def.optionsMap.keys()).reduce((agg, k: string) => ({ ...agg, [k]: k }), {}),
    ),
    ...schema.omit({
      [union.discriminator]: true,
    } as any).shape,
  });
};
